// extracted by mini-css-extract-plugin
export default {"transfer_card":"s_transfer_card__iEriR","header":"s_header__9RErF","transferModal":"s_transferModal__3vcnm","timeWrap":"s_timeWrap__lvu6a","timeWrapForAll":"s_timeWrapForAll__V8Nt0"};